import Vue from "vue";
import { Dialog } from "vant"; // 弹框

Vue.use(Dialog);
let dialog = Dialog; // 弹框
// 显示弹框
export const showDialog = (params) => {
  const { msg, status } = params;
  console.log("状态码" + status);
  dialog
    .alert({
      message: msg,
      className: "showDialogClass",
    })
    .then(() => {
      dialog.close();
    });
};
export const hideDialog = () => {
  dialog.close();
};

export default {
  showDialog,
  hideDialog,
};
